var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"sf-main"},[_c('div',{staticClass:"sf-cnt"},[(_vm.dataLoaded)?_c('Form',{attrs:{"settings":_vm.form,"type":_vm.type,"error":_vm.error,"message":_vm.message},on:{"submit":_vm.createLead}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }